import React from 'react';
import KickImage from 'Reuseables/KickImage';

/** CSS import */
import Styles from './Banner.module.scss';
import Slider from 'react-slick';
import SliderItem from './Components/Organisms/SliderItem';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';

import '../../../../../styles/scss/Blog.scss';
import useFetchHomeBannerData from 'Pages/Blog/Hooks/useFetchHomeBannerData';
import moment from 'moment';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

const Banner: React.FC = () => {
  const settings = React.useMemo(() => {
    return {
      customPaging: function (i) {
        return (
          <a>
            <div className={Styles['dot']} />
          </a>
        );
      },
      className: Styles['slick-active'],
      dotsClass: `${Styles['slick-dots']} ${Styles['slick-thumb']} blog-slick-thumb`,
      autoplay: false,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
  }, []);

  const { fetchBannerData, isError, isFetching, data, error } =
    useFetchHomeBannerData();

  React.useEffect(() => {
    fetchBannerData();
  }, []);

  const { isDesktopView } = useGetViewType();

  const Placeholder = React.useMemo(
    () => (
      <div className={Styles['placeholder']}>
        <RectShape
          color="#eeeeee"
          style={{ width: isDesktopView ? '75%' : '100%', height: 300 }}
        />
        {isDesktopView && <TextBlock rows={10} color="#eeeeee" />}
      </div>
    ),
    [],
  );

  return (
    <div className={Styles['wrapper']}>
      <ReactPlaceholder ready={!isFetching} customPlaceholder={Placeholder}>
        <Slider {...settings}>
          {data?.map((item, index) => {
            const divHelper = document.createElement('div');
            divHelper.innerHTML = item.body;
            const text = divHelper.textContent || divHelper.innerText || '';
            return (
              <SliderItem
                key={`slider-item-${index}`}
                img={item?.thumbnail?.URL ?? 'https://picsum.photos/500'}
                title={item.title}
                subtitle={item.subtitle ? `${item.subtitle}...` : ''}
                date={moment(item.created_at).format('MMMM DD')}
                year={moment(item.created_at).format('YYYY')}
                link={`/kickavenews/${item.slug}`}
              />
            );
          })}
        </Slider>
      </ReactPlaceholder>
    </div>
  );
};

export default Banner;
